<template>
  <q-toggle>
    <slot />
  </q-toggle>
</template>
